"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var rest_resource_1 = tslib_1.__importDefault(require("rest-resource"));
var related_1 = require("./related");
var lodash_1 = require("lodash");
var normalization_1 = require("rest-resource/dist/helpers/normalization");
var BaseResource = /** @class */ (function (_super) {
    tslib_1.__extends(BaseResource, _super);
    function BaseResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(BaseResource, "normalization", {
        /**
         * GETTER -- Automatically generate StringNormalizer normalizer for any related fields
         */
        get: function () {
            if (this._normalization) {
                return this._normalization;
            }
            this._normalization = {};
            var rel = this.related;
            if ('function' === typeof rel) {
                rel = rel();
            }
            for (var relatedKey in rel) {
                this._normalization[relatedKey] = new normalization_1.StringNormalizer();
            }
            return this._normalization;
        },
        set: function (value) {
            this._normalization = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Since we are returning a custom interface "PagedContentNegotiatorListResponse" response, we're just overriding the types here
     * @param options ListOpts
     */
    BaseResource.list = function (options) {
        return rest_resource_1.default.list.call(this, options);
    };
    /**
     * Allow a custom Resource.all() method to recursively call list() except with all other pages
     * @param options
     */
    BaseResource.all = function (options) {
        if (options === void 0) { options = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var content, otherPages, allResources, promises;
            var _a;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.list(options)];
                    case 1:
                        content = _b.sent();
                        otherPages = content.otherPageNumbers();
                        allResources = (_a = {},
                            _a[content.page] = content.resources,
                            _a);
                        promises = otherPages.map(function (page) {
                            var thisPageQuery = Object.assign({}, content.query, { page: page });
                            return _this.list(Object.assign({}, options, { query: thisPageQuery })).then(function (res) {
                                allResources[page] = res.resources;
                            });
                        });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 2:
                        _b.sent();
                        return [2 /*return*/, lodash_1.flatten(Object.values(allResources))];
                }
            });
        });
    };
    BaseResource.filter = function (filterArgs) {
        return this.list({ query: filterArgs });
    };
    BaseResource.filterAll = function (filterArgs) {
        return this.all({ query: filterArgs });
    };
    BaseResource.search = function (searchString, filterArgs) {
        if (filterArgs === void 0) { filterArgs = {}; }
        var query = Object.assign(filterArgs, { search: searchString });
        return this.list({ query: query });
    };
    BaseResource.searchAll = function (searchString, filterArgs) {
        if (filterArgs === void 0) { filterArgs = {}; }
        var query = Object.assign(filterArgs, { search: searchString });
        return this.all({ query: query });
    };
    BaseResource.toResourceName = function () {
        if (this.name.length < 3) {
            return "Resource[" + this.endpoint + "]";
        }
        return _super.toResourceName.call(this);
    };
    BaseResource.options = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._metaOptions) {
                            return [2 /*return*/, this._metaOptions];
                        }
                        return [4 /*yield*/, this.client.options(this.endpoint)];
                    case 1:
                        result = (_a.sent());
                        this._metaOptions = result.data;
                        return [2 /*return*/, this._metaOptions];
                }
            });
        });
    };
    BaseResource.metaFilters = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var meta;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.options()];
                    case 1:
                        meta = _a.sent();
                        return [2 /*return*/, meta.filter_fields];
                }
            });
        });
    };
    BaseResource.getFormset = function (pickFields) {
        if (!pickFields || !pickFields.length) {
            return this.defaultFormset;
        }
        return lodash_1.pick(this.defaultFormset, pickFields);
    };
    BaseResource.prototype.getFormset = function (pickFields) {
        return this.getConstructor().getFormset(pickFields);
    };
    BaseResource.prototype.toString = function () {
        if (this.attributes.name) {
            return this.attributes.name;
        }
        else if (this.attributes.code) {
            return this.attributes.code;
        }
        else if (this.attributes.description) {
            return this.attributes.description;
        }
        return _super.prototype.toString.call(this);
    };
    BaseResource.cacheMaxAge = 60;
    BaseResource.RelatedManagerClass = related_1.SigmaRelatedManager;
    BaseResource.defaultFormset = {};
    BaseResource._isRESTResource = true;
    BaseResource._shouldExport = true;
    BaseResource._metaOptions = null;
    return BaseResource;
}(rest_resource_1.default));
exports.default = BaseResource;
//# sourceMappingURL=base.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/base.js
// module id = iX9c
// module chunks = 0